import { Component, computed, HostBinding, inject, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, NgClass } from '@angular/common';
import { LorenzFormControl } from '../../lorenz-form-control';
import { LibFormValidityDotComponent } from '../../components/validity-dot/lib-form-validity-dot.component';
import { LorenzFormGroup } from '../../lorenz-form-group';
import { TranslateModule } from '@ngx-translate/core';
import { LorenzFormComponentDisplayOptions, LorenzFormComponentOptionsDefault } from '../../interfaces/lorenz-form-component-options.interface';
import { getLorenzFormLayoutEnumString, LorenzFormLayoutEnum } from '../../enums/lorenz-form-layout.enum';
import { LibSharedService } from '@lib/shared';

@Component({
	selector: 'lib-form-control-text',
	imports: [CommonModule, FormsModule, ReactiveFormsModule, NgClass, LibFormValidityDotComponent, TranslateModule],
	templateUrl: './lib-form-control-text.component.html',
	styleUrl: './lib-form-control-text.component.scss'
})
export class LibFormControlTextComponent implements OnInit {
	private readonly libSharedService = inject(LibSharedService);

	@Input({ required: true, alias: 'control' }) lorenzFormControl!: LorenzFormControl;

	@Input({ required: false, alias: 'options' }) lorenzFormComponentDisplayOptions: LorenzFormComponentDisplayOptions = {};

	@HostBinding('attr.class') hostCssClass = '';

	lorenzFormGroup!: LorenzFormGroup;
	disabled = false;

	ngOnInit() {
		// FOR DEBUGGING
		// if (this.lorenzFormControl.getKey() === 'gvp_entgelt') {
		// 	console.log(`${this.lorenzFormControl.getKey()}`, this.lorenzFormControl.payload);
		// }

		this.lorenzFormGroup = this.lorenzFormControl.parent as LorenzFormGroup;

		this.lorenzFormControl.payload.displayOptions = this.lorenzFormComponentDisplayOptions;

		// prettier-ignore
		this.hostCssClass = [
				this.lorenzFormControl.getKey(),
				getLorenzFormLayoutEnumString(this.lorenzFormComponentDisplayOptions.layout ?? null)
			].join(' ');

		if (!this.lorenzFormControl.value) {
			this.lorenzFormControl.patchValue(this.lorenzFormControl.payload?.originalValue);
		}
	}

	get hasLayoutFloatingLabels(): boolean {
		return this.lorenzFormComponentDisplayOptions.layout === LorenzFormLayoutEnum.FLOATING_LABELS;
	}

	get defaultValues(): string | null {
		return (this.textDefaults.length ?? 0) > 0 ? 'defaultValues' : null;
	}

	get placeholder(): string | null {
		if (this.hasLayoutFloatingLabels) {
			return ' ';
		} else if (this.lorenzFormControl.hasPlaceholder()) {
			return this.lorenzFormControl.getPlaceholder();
		}

		return null;
	}

	get showErrorMessages(): boolean {
		return this.lorenzFormControl.showErrors() && (this.lorenzFormComponentDisplayOptions.showErrorMessages ?? LorenzFormComponentOptionsDefault.showErrorMessages);
	}

	get textDefaults() {
		return this.textDefaultsLocalized();
	}

	textDefaultsLocalized = computed(() => {
		const lang = this.libSharedService.getCurrentLanguage();
		return this.lorenzFormControl.getTextDefaults(lang) || [];
	});
}
